import { Avatar, AvatarFallback } from "@volca/ui/components/ui/avatar";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { cn } from "@volca/ui/lib/utils";
import { formatDateTimeWithZone, formatRelativeTime } from "@/core/utils/date";

interface MessageDisplayProps {
  message: string;
  mediaUrls: string[];
  isOutbound: boolean;
  createdAt: string;
  showTime?: boolean;
}

export const MessageDisplay = ({
  message,
  isOutbound,
  mediaUrls,
  createdAt,
  showTime,
}: MessageDisplayProps) => (
  <Stack
    align="start"
    className={cn("max-w-[330px] self-start", {
      "self-end": isOutbound,
      "pb-4": showTime,
    })}
    gap={2}
  >
    <Stack
      align="start"
      gap={4}
      className={cn("rounded-lg bg-neutral p-3", {
        "self-end bg-accent-teal-subtle": isOutbound,
      })}
    >
      {message && <Text>{message}</Text>}
      {mediaUrls.map((mediaUrl, index) => (
        <img
          src={mediaUrl}
          alt={`Message attachment ${index + 1}`}
          className="max-h-[200px] w-[200px] object-contain"
        />
      ))}
    </Stack>
    {showTime && (
      <Stack
        direction="row"
        align="center"
        gap={2}
        className={cn({ "self-end": isOutbound })}
      >
        <Tooltip>
          <TooltipTrigger>
            <Text variant="caption" className="text-subtle">
              {formatRelativeTime(createdAt)}
            </Text>
          </TooltipTrigger>
          <TooltipContent>{formatDateTimeWithZone(createdAt)}</TooltipContent>
        </Tooltip>
        {isOutbound && (
          <Tooltip>
            <TooltipTrigger>
              <Avatar className="h-[22px] w-[22px] border-2 border-ink">
                <AvatarFallback className="border-none bg-transparent p-0 text-sm font-medium text-ink">
                  v
                </AvatarFallback>
              </Avatar>
            </TooltipTrigger>
            <TooltipContent className="block">
              This orange circle signifies an automated Volca text sent from
              your business phone number to this customer.
              <br />
              <br />
              Soon you'll be able to send back your own messages as needed, and
              we will mark those differently for you
            </TooltipContent>
          </Tooltip>
        )}
      </Stack>
    )}
  </Stack>
);
